import __ from 'localisation';

export const crsOptions = [
  {
    id: 'passive_nfe',
    title: __('crs_passive_nfe'),
  },
  {
    id: 'active_nfe',
    title: __('crs_active_nfe'),
  },
  {
    id: 'other',
    title: __('crs_other'),
  },
];
